module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI0YWI0NjhlZGNhNWZmMWFkOWQzNjI5MjFmZDQ1NWU3Zi5wbmciOw=="